import { render, staticRenderFns } from "./DollarsBar.vue?vue&type=template&id=235e70d3"
import script from "./DollarsBar.vue?vue&type=script&lang=js"
export * from "./DollarsBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports